<template>
  <div class="home">
    <div class="header">
      <img class="header-logo" src="../assets/img/logo.png"/>
      <div class="time">
        <div>
          <span>{{ time }}</span>
          <span class="font18">{{ nowTime }}</span>
        </div>
      </div>
    </div>
    <div class="contant">
      <div class="con_left">
        <div class="left_l left_top">
          <div class="l_title"><span>声量趋势</span></div>
          <div id="line" class="line"></div>
        </div>
        <div class="left_l left_bottom">
          <div class="l_title"><span>传播平台分布</span></div>
          <div id="bar" class="bar"></div>
        </div>
        <div class="left_l left_center">
          <div class="l_title"><span>蒙牛情感分布</span></div>
          <div id="pie" class="pie"></div>
        </div>
      </div>
      <div class="con_center">
        <div class="ciyun_center">
          <div class="ciyun_center_top">
            <div class="card">
              <div class="card_title">曝光量</div>
              <div class="card_day">当日累计</div>
              <div class="card_list" v-if="mengniuStatistics.length > 0">
                <div class="card_list_item">
                  <div class="card_list_item_title green">蒙牛</div>
                  <div class="card_list_item_num green">{{ mengniuStatistics && mengniuStatistics[0].viewCount }}</div>
                </div>
                <div class="card_list_item">
                  <div class="card_list_item_title blue">伊利</div>
                  <div class="card_list_item_num blue">{{ yiliStatistics && yiliStatistics[0].viewCount }}</div>
                </div>
              </div>
            </div>
            <div class="card">
              <div class="card_title">声量</div>
              <div class="card_day">当日累计</div>
              <div class="card_list" v-if="mengniuStatistics.length > 0">
                <div class="card_list_item">
                  <div class="card_list_item_title green">蒙牛</div>
                  <div class="card_list_item_num green">{{ mengniuStatistics && mengniuStatistics[0].volume }}</div>
                </div>
                <div class="card_list_item">
                  <div class="card_list_item_title blue">伊利</div>
                  <div class="card_list_item_num blue">{{ yiliStatistics && yiliStatistics[0].volume }}</div>
                </div>
              </div>
            </div>
            <div class="card">
              <div class="card_title">互动量</div>
              <div class="card_day">当日累计</div>
              <div class="card_list" v-if="mengniuStatistics.length > 0">
                <div class="card_list_item">
                  <div class="card_list_item_title green">蒙牛</div>
                  <div class="card_list_item_num green">{{ mengniuStatistics && mengniuStatistics[0].interactCount }}</div>
                </div>
                <div class="card_list_item">
                  <div class="card_list_item_title blue">伊利</div>
                  <div class="card_list_item_num blue">{{ yiliStatistics && yiliStatistics[0].interactCount }}</div>
                </div>
              </div>
            </div>
          </div>
          <div id="ciyun1" class="ciyun1"></div>
        </div>
        <div class="center_bottom">
          <div class="left_l">
            <div class="l_title"><span>微博热搜榜</span></div>
            <div class="scroll_weibo border">
              <div class="scroll_header">
                <div class="scroll_header_item">最高排名</div>
                <div class="scroll_header_item">关键词</div>
                <div class="scroll_header_item">上榜时间(min)</div>
                <div class="scroll_header_item">热搜指数</div>
              </div>
              <vue-seamless-scroll
                  :data="weibolistData"
                  class="seamless-warp"
                  :class-option="classOption"
              >
                <ul>
                  <li v-for="(item, index) in weibolistData" :key="index">
                    <div class="scroll_main">
                      <div class="scroll_main_item">{{ item.rank }}</div>
                      <div class="scroll_main_item">{{ item.topic }}</div>
                      <div class="scroll_main_item">{{ item.count }}</div>
                      <div class="scroll_main_item">
                        {{ item.searchIndex }}
                        <span v-if="item.searchIndexStatus === 'up'" style="color: #E3595F">↑</span>
                        <span v-if="item.searchIndexStatus === 'down'" style="color: #1794FF">↓</span>
                        <span v-if="item.searchIndexStatus === 'unchanged'">-</span>
                      </div>
                    </div>
                  </li>
                </ul>
              </vue-seamless-scroll>
              <div class="zhezhao"></div>
            </div>
          </div>
          <div class="left_l">
            <div class="l_title"><span>热帖排行榜</span></div>
            <div class="scroll border">
              <vue-seamless-scroll
                  :data="listData"
                  class="seamless-warp"
                  :class-option="classOption"
              >
                <ul>
                  <li v-for="(item, index) in listData" :key="index">
                    <div class="li_title">
                      <div class="t_left">
                        <div style="color: #FFFFFF;font-weight: 600">
                          <img class="img" src="../assets/img/j.png">{{ index + 1 }}.
                        </div>
                        <div>{{ item.nickName }}
                          <span class="t_time">{{ item.publishedAt }}</span>
                        </div>

                        <div v-if="index <= 2" style="color: #e40209">
                          {{ item.num }}
                        </div>
                        <div v-else style="color: #50ce3e">{{ item.num }}</div>
                      </div>

                    </div>
                    <div class="li_text">
                      {{ item.text }}
                    </div>
                  </li>
                </ul>
              </vue-seamless-scroll>
              <div class="zhezhao"></div>
            </div>
          </div>
        </div>
      </div>
      <div class="con_right">
        <div class="left_l right_center">
          <div class="l_title"><span>蒙牛KOL表现</span></div>
          <div class="scroll2 border">
            <el-carousel
                height="200px"
                direction="vertical"
                :autoplay="true"
                indicator-position="none"
                :interval="5000"
            >
              <el-carousel-item v-for="(item, index) in rawList" :key="index">
                <div class="tip">
                  <div>
                    平台：
                    <span>{{ item.platform }}</span>
                  </div>
                  <div>
                    曝光：
                    <span>{{ item.viewCount }}</span>
                  </div>
                  <div>
                    转发量：
                    <span>{{ item.repostCount }}</span>
                  </div>
                  <div>
                    评论：
                    <span>{{ item.commentCount }}</span>
                  </div>
                  <div>
                    点赞：
                    <span>{{ item.likeCount }}</span>
                  </div>
                  <div class="">
                    互动量：
                    <span>{{ item.interactCount }}</span>
                  </div>
                </div>
                <div class="center_title">
                  <div class="topic">{{ item.topic }}</div>
                  <div>
                    {{ item.publishedAt && item.publishedAt.substring(5) }}
                  </div>
                </div>
                <div class="center_text">{{ item.content }}</div>
              </el-carousel-item>
            </el-carousel>
          </div>
        </div>
        <div class="left_l right_center">
          <div class="l_title"><span>蒙牛词云</span></div>
          <div class="ciyun border">
            <div id="ciyun" class="ciyun_word"></div>
          </div>
        </div>
        <div class="left_l right_center left_center">
          <div class="l_title"><span>蒙牛负面舆情</span></div>
          <div class="scroll scroll1 border">
            <vue-seamless-scroll
                :data="listData1"
                class="seamless-warp"
                :class-option="classOption1"
            >
              <ul>
                <li v-for="(item, index) in listData1" :key="index">
                  <div class="li_title">
                    <div class="t_left t_left1">
                      <div style="color: #FFFFFF;font-weight: 600">
                        <img class="img" src="../assets/img/e.png">{{ index + 1 }}.
                      </div>

                      <div>{{ item.nickName }}</div>
                      <div class="t_time">{{ item.publishedAt }}</div>
                    </div>
                  </div>
                  <div class="li_text li_text1">{{ item.text }}</div>
                </li>
              </ul>
            </vue-seamless-scroll>
            <div class="zhezhao zhezhao1"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import * as echarts from "echarts";
import "echarts-wordcloud/dist/echarts-wordcloud.min";
import vueSeamlessScroll from "vue-seamless-scroll";
import {formatTime} from "../utils/time";
// 接口获取
import {distribution, hot, negative, raw, sentiment, token, Trend, word,} from "@/utils/api.js";
import {mengniuWord, statistics, weibo} from "../utils/api";

export default {
  name: "Home",
  components: {
    //组件
    vueSeamlessScroll,
  },
  data() {
    return {
      Interval5: null,
      Interval60: null,
      Interval20: null,
      sentimentList: [], //蒙情感分布
      rawList: [[]], // 蒙⽜KOL表现
      distributionData: {},
      trendData: {}, //声量趋势数据获取
      hour: [],
      nowTime: "",
      time: "",
      color: ["#8fc31f", "#e4a33d", "#007ae1", "#ff0000", "#1ca8dd"],
      color1: ["#1EE7E7", "#2B8EF3", "#8FD7FB"],
      color2: ["#BEE5FB", "#1794FF", "#1EE7E7"],
      listData: [],
      listData1: [],
      listData2: [],
      weibolistData: [],
      value: [],
      worldValue: [],
      globeState: false,
      yearState: false,
      choicesSelect: null,
      mengniuStatistics: [],
      yiliStatistics: [],
    };
  },
  created() {
    let token = sessionStorage.getItem("access_token");
    if (token) {
      this.globeState = true;
      this.$nextTick(function () {
        this.getTrend();
        this.getDistribution();
        this.getSentiment();
        this.getRaw();
        this.getnNegative();
        this.getWord();
        this.getWorldWord();
        this.getHot();
        this.getWeiboRank();
        this.getStatistics();
      });
    } else {
      this.getToken();
    }
  },
  computed: {
    classOption() {
      return {
        step: 1, // 数值越大速度滚动越快
        limitMoveNum: 3, // 开始无缝滚动的数据量 this.dataList.length
        // direction: 1 ,// 0向下 1向上 2向左 3向右
        // openWatch: true, // 开启数据实时监控刷新dom
      };
    },
    classOption1() {
      return {
        step: 1, // 数值越大速度滚动越快
        limitMoveNum: 1, // 开始无缝滚动的数据量 this.dataList.length
        // direction: 1 ,// 0向下 1向上 2向左 3向右
        // openWatch: true, // 开启数据实时监控刷新dom
        // singleHeight: 110,单步运动停止的高度
        // waitTime:0//单步停止等待时间(默认值1000ms)
      };
    },
  },
  mounted() {
    this.gettime5min();
    this.gettime60min();
    this.gettime20min();
    this.time = formatTime();
    this.currentTime();
    this.initChart();
    this.initWorldChart();
  },
  beforeDestroy() {
    clearInterval(this.Interval5);
    clearInterval(this.Interval20);
    clearInterval(this.Interval60);
    this.Interval5 = null;
    this.Interval20 = null;
    this.Interval60 = null;
  },
  methods: {
    replaceStr(str) {
      let str1 = str.substring(5);
      return str1;
    },
    gettime5min() {
      this.Interval5 = setInterval(() => {
        //五分钟
        this.getTrend();
        this.getStatistics();
        this.getDistribution();
        this.getSentiment();
      }, 1000 * 5 * 60);
    },
    gettime60min() {
      this.Interval60 = setInterval(() => {
        //60分钟
        this.getRaw();
        this.getnNegative();
        this.getHot();
        this.getWeiboRank();
      }, 1000 * 60 * 60);
    },
    gettime20min() {
      this.Interval20 = setInterval(() => {
        //20分钟
        this.getWord();
        this.getWorldWord();
      }, 1000 * 20 * 60);
      //
    },
    getToken() {
      token({
        appKey: "mengniu",
        appSecret: "JIxC5mGtK2G8cIdz",
      })
          .then((res) => {
            if (res.data.code == 200) {
              sessionStorage.setItem("access_token", res.data.data.token);
              sessionStorage.setItem("expires_in", res.data.data.expires_in);
              this.globeState = true;
              this.$nextTick(function () {
                this.getTrend();
                this.getDistribution();
                this.getSentiment();
                this.getRaw();
                this.getnNegative();
                this.getWorldWord();
                this.getWord();
                this.getHot();
                this.getWeiboRank();
                this.getStatistics();
              });
              setTimeout(this.getWord(), 1000);
              setTimeout(this.getWorldWord(), 1000);
            }
          })
          .catch((err) => {
            console.log(err);
          });
    },
    getToken01() {
      token({
        appKey: "mengniu",
        appSecret: "JIxC5mGtK2G8cIdz",
      })
          .then((res) => {
            if (res.data.code == 200) {
              sessionStorage.setItem("access_token", res.data.data.token);
              sessionStorage.setItem("expires_in", res.data.data.expires_in);
              this.globeState = true;
              this.$nextTick(function () {
                this.getTrend();
                this.getDistribution();
                this.getSentiment();
                this.getRaw();
                this.getnNegative();
                this.getWord();
                this.getWorldWord();
                this.getHot();
                this.getWeiboRank();
                this.getStatistics();
              });
            }
          })
          .catch((err) => {
            console.log(err);
          });
    },
    getDistribution() {
      let that = this;
      // 平台分布
      distribution()
          .then((res) => {
            if (res.data.code == 200) {
              that.distributionData = res.data.data;
              that.bar();
            }
          })
          .catch((err) => {
            console.log(err);
          });
    },
    getTrend() {
      let that = this;
      // 声量趋势
      Trend()
          .then((res) => {
            if (res.data.code == 200) {
              that.trendData = res.data.data;
              that.line();
            } else if (res.data.code == 400) {
              this.globeState = false;
              this.getToken01();
            }
          })
          .catch((err) => {
            console.log(err);
          });
    },
    getSentiment() {
      // 蒙情感分布
      sentiment()
          .then((res) => {
            if (res.data.code == 200) {
              let sentimentList = res.data.data;
              let temp = [];
              sentimentList.map((item) => {
                temp.push({
                  name: item.sentiment,
                  value: item.buzz,
                });
              });
              this.sentimentList = temp;
              this.pie();
            }
          })
          .catch((err) => {
            console.log(err);
          });
    },
    getRaw() {
      // 蒙⽜KOL表现
      raw()
          .then((res) => {
            if (res.data.code == 200) {
              this.rawList = res.data.data;
              this.yearState = true;
            }
          })
          .catch((err) => {
            console.log(err);
          });
    },
    getnNegative() {
      // 蒙⽜负⾯舆情
      negative()
          .then((res) => {
            if (res.data.code == 200) {
              let negative = res.data.data;
              let temp = [];
              negative.map((item) => {
                temp.push({
                  text: item.content,
                  nickName: item.nickName,
                  publishedAt: item.publishedAt,
                });
              });
              this.listData1 = temp;
            }
          })
          .catch((err) => {
            console.log(err);
          });
    },
    getWord() {
      // 词云展示
      mengniuWord()
          .then((res) => {
            if (res.data.code == 200) {
              let word = res.data.data;
              let intnum = parseInt(100 / word.length);
              let temp = [];
              word.sort((a, b) => {
                return b[1] - a[1];
              });
              if (word.length <= 100) {
                for (let i = 0; i < intnum; i++) {
                  word = word.concat(word);
                }
              }
              word.map((item) => {
                temp.push({
                  name: item.word,
                  value: item.freq,
                });
              });
              this.value = temp.slice(0, 100);
              this.initChart();
            }
          })
          .catch((err) => {
            console.log(err);
          });
    },
    getWorldWord() {
      // 世界杯词云展示
      word()
          .then((res) => {
            if (res.data.code == 200) {
              let word = res.data.data;
              let intnum = parseInt(100 / word.length);
              let temp = [];
              word.sort((a, b) => {
                return b[1] - a[1];
              });
              if (word.length <= 100) {
                for (let i = 0; i < intnum; i++) {
                  word = word.concat(word);
                }
              }
              word.map((item) => {
                temp.push({
                  name: item.word,
                  value: item.freq,
                });
              });
              this.worldValue = temp.slice(0, 100);
              this.initWorldChart();
            }
          })
          .catch((err) => {
            console.log(err);
          });
    },
    getHot() {
      // 热帖排⾏
      hot()
          .then((res) => {
            if (res.data.code == 200) {
              let hot = res.data.data;
              let temp = [];
              hot.map((item) => {
                temp.push({
                  title: item.topic,
                  text: item.content,
                  num: item.interact,
                  nickName: item.nickName,
                  publishedAt: item.publishedAt,
                });
              });

              this.listData = temp;
            }
          })
          .catch((err) => {
            console.log(err);
          });
    },
    getWeiboRank() {
      // 热帖排⾏
      weibo()
          .then((res) => {
            if (res.data.code == 200) {
              let weibo = res.data.data;
              let temp = [];
              weibo.map((item) => {
                if (item.rank === 0) {
                  item.rank = "-"
                } else if (item.rank === 1) {
                  item.rank = "NO.1"
                } else if (item.rank === 2) {
                  item.rank = "NO.2"
                } else if (item.rank === 3) {
                  item.rank = "NO.3"
                }
                temp.push({
                  rank: item.rank,
                  topic: item.topic,
                  count: item.count,
                  searchIndex: item.searchIndex,
                  // 搜索指数状态 up-上升 down-下降 unchanged-没有改变
                  searchIndexStatus: item.searchIndexStatus,
                });
              });

              this.weibolistData = temp;
            }
          })
          .catch((err) => {
            console.log(err);
          });
    },
    getStatistics() {
      // 统计
      statistics()
          .then((res) => {
            if (res.data.code == 200) {
              this.mengniuStatistics = res.data.data.filter(o => o.brandName === "蒙牛");
              this.yiliStatistics = res.data.data.filter(o => o.brandName === "伊利");
            }
          })
          .catch((err) => {
            console.log(err);
          });
    },
    initWorldChart() {
      let that = this;
      this.chart = echarts.init(document.getElementById("ciyun1"));

      let maskImage = new Image();
      maskImage.src =
          "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAA3QAAAEsCAYAAACL0vEIAAAAAXNSR0IArs4c6QAAAARzQklUCAgICHwIZIgAACAASURBVHic7d1ZsBz1mabxRwcQQvsCWkASILQgQCtgDGaxWew2YIOxwXu7m/F4bju6Ozr6ZqbbnpiY6aueiJmYmHa3PV7xAsa4DcY2GMxizKoFAUILixCbJCShIxBCEtZc/DOpVKnOUdU5VfVVVj2/iC++dMSpzFf2heONrMocgSRJhzsOGJ3tfEZV7WOz41GF42OBkdnOj6vnmGxGAkdnx8Wdz1GFnU9fYeczorCLU8vBqvlTYefzXmG/BxyoOs5nf9Xelx3vz46r591s8uO9hZ0fv5MdF3c+e7ItSdL7Bvo/PElSeYwHxhVmbGFXz5jCHkMqbcXj4qjz7Kmat7MpHr9V2NWzu7Dz6W/rv0CS1FQWOkmKN7HGTCjsfMbX2OOyLQ1VP5Vit6vGzufNwq4eSVIQC50kNc9xwGRgSraLM6lqT8yO85HKamc2b2Z7R41dnO3Z9uujktQEFjpJGtjRwAnZHF/Y1TMlm+Pxq4pSPfYAb5DK3fbsuHq2FfY20u8UJUlVLHSSetEUYCowLdvVc0Jhe/dMireTVOq2Fnb1bMn29qCMkhTCQiepm4wFpgMzsl0907KZTrr7Jqm7HCAVu9cLu3pey/ZbQRklqaksdJLKYhxwIqmsnVh1PKMw46ICSiqN3aRil8+rNfar2d9JUkez0EnqFNOAmcBJhV09Ps1RUrv0A68MMC9nsyUsnSRlLHSS2mUqMCubmTX2TNKLpSWpDPZTKXaba+zNpN/0SVJLWegkNcsxwMnZzM6meDwLGBWWTpLaay+p1L2Uzaaq402kUihJw2Khk9SI44BTsjm5sPM5MSiXJJXNq1SK3SbgxcJ+Ed/TJ6lOFjpJ1UYApw4y0+KiSVJP2AK8MMgcjIsmqdNY6KTeNRmYM8CcGphLkjSwF4DnB5gdgbkkBbHQSd1vBjAXOK3G9qXZktQddgLPARtr7NcCc0lqMQud1D1mAPOymZtNfjwmMJckKc7bpFK3EdhQ2Buw6EldwUInlc9EYH6NmQeMDcwlSSqPt0ilbn2NeTMwl6QGWeikzragMPML2weTSJJaYSuwLpv1heN1kaEkDcxCJ3WG8cDpwMJsF0eSpGjPVs3abPdHhpJkoZMiTCMVt+o5KTKUJEkNeoVKsVsLPJPtLZGhpF5joZNaawZwBnBmtvOZEhlKkqQW2U4qdvk8nW0fwCK1iIVOap4TgLNI5a04kyNDSZIUbAep2FXP1shQUrew0ElDMxpYlM1Z2SwCpkaGkiSpJLYCTwFrCnsNsCcylFRGFjqpPqdTKXD5nBaaSJKk7vI88CSVcreG9Ps8SYOw0EmHmwQsBpZU7ZGRoSRJ6jH7SAXvSWB1Nk8COyNDSZ3GQifBXFJpW5rtJcDs0ESSJKmWl6iUu1XZ3hiaSApmoVOvGQEsI5W3fC8FxkaGkiRJQ/IWqditAlYW9sHIUFI7WejU7UaTitvybOclTpIkdae81K0EVmTbh62oa1no1G3GAWeTCly+Tw9NJEmSIj1LKnZPFPbu0ERSE1noVHZ5gSvO/NBEkiSpk60nlbriWPBUWhY6lc1I4FzgnGzOBRaEJpIkSWW2DngMeDybx0hP2JRKwUKnMlhGKm75LImNI0mSuthqUqnLZ2VsHGlwFjp1ojnAB4Dzsv0B4OjQRJIkqRcdAB4tzCOkF6BLHcNCp04wgVTe8vkAcEJoIkmSpMNto1Ls8tkVmkg9z0KnKIuBDxZmYWwcSZKkhq0FHi7Mk7Fx1IssdGqXycD5pPJ2fjajQxNJkiQ1zx7gj9k8nO0doYnUEyx0aqWFwAWF8X1wkiSpVzwLPFSYtbFx1K0sdGqmo0nF7UPZXABMCk0kSZIUbyep1P0hm4dID1yRhs1Cp+GaAlxYmA/GxpEkSep4DwMPFmZ7bByVmYVOQ3EqcBGVEucDTSRJkoZmLZVi9wDwQmwclY2FTvU6A7g4m4uAmbFxJEmSus7LpFJ3fzbPxMZRGVjoNJhlVErcxcDxsXEkSZJ6xhtUit39wMrYOOpUFjpVOxu4BPhwtseHppEkSVI/cB/w+2w/EZpGHcVCJ4DlpAKXz7jALJIkSRrYblKxy2dFYBZ1AAtd71oEfCSbS/FOnCRJUtn0A/cA92azJjaOIljoess8UnnLS9wJsXEkSZLUJNuolLt7gA2xcdQuFrruNx24rDCzY+NIkiSpxV4CfleY12PjqJUsdN1pFHB5NpcBZ8XGkSRJUpCnSKXu7mz2xsZRs1nousv5wBWkIndRcBZJkiR1lgdIpe4u4I/BWdQkFrrymwN8lFTkrsAnVEqSJGlwu0ml7i7gt8DzsXE0HBa6choJfKwwc2PjSJIkqaQ2Ar8pzL7YOGqUha5cllIpcR8JziJJkqTuci+VYrcqOIvqZKHrfOOAjwN/lu3psXEkSZLU5V4H7gR+ne3dsXE0GAtd51pGKnAfBy4MziJJkqTe9CCp1N0JrAzOohosdJ1lJHAVcGW2Z8TGkSRJkgB4DbgD+FW2/a1dh7DQdYZ5VIrcFcFZJEmSpMHcRaXYbQjO0vMsdLEuAa4GPgEsCM4iSZIkNWId8EvgduC+4Cw9y0LXfmNIBe4TpDI3PjaOJEmSNCz9pFL3y2zejo3TWyx07XMycA3wSeCy4CySJElSK/wO+HfgF8Cm4Cw9wULXestJRe4aYElwFkmSJKkdVpNK3S+AFcFZupqFrnUuBa7NZlZwFkmSJCnCZuC2bO4JztKVLHTNdw3wKVKRmxCcRZIkSeoEu0il7ueku3ZqEgtdcxwLXAd8Otv+9ypJkiQd7iBwazY/A96NjVN+Fo/hmUClyF0VnEWSJEkqkztIpe5W0h08DYGFbmgmA5/JxheBS5IkSUN3F3BLNjuCs5SOha4xx5NK3PWkh55IkiRJao57gJtJxe6N4CylYaGrzyTghmwscpIkSVLr3AP8NJudwVk6noVucONIJe6z+NVKSZIkqZ3uAn5CKna7g7N0LAtdbUcDn8vGh51IkiRJce4AfpzNgeAsHcdCd7jrSEXu+uggkiRJkt53M6nU3RodpJNY6CouB74AfBEYGZxFkiRJ0uH2ATcBPwTuDs7SESx0cA6pxH0BmBqcRZIkSdKRbaVS7B4PzhKqlwvdKcCXslkQG0WSJEnSEKwDfpDNi7FRYvRioRtNpchdFJxFkiRJ0vA9CHyfVOz2BGdpq14rdFcDXyG9HFySJElSd7kF+C5we3SQdumVQrcU+HNSmZscnEWSJElS6+wglbrvAauCs7Rctxe6CcBfZLM0NIkkSZKkdloFfCebXaFJWqibC93VwF+S3isnSZIkqTfdCvw/uvRrmN1Y6OYB/wG4ETghOIskSZKkeNuAbwPfAjYEZ2mqo6IDNNmfA/9Ieq/cmNgokiRJkjrEGOBCYAlwEFgdG6d5uuUO3TLgPwJfBY4JziJJkiSpc+0H/g34V2BlcJZhK/sduhHA10h35a6h/P8eSZIkSa11FHAucDapT6yIjTM8Zb5Dtxz4T6RCJ0mSJElD8U3gXyhpsSvrHa0bgX8APhkdRJIkSVKpnU36CdefKOFXMMtW6BYA/xn4OjA7OIskSZKk7nAScCUwBXgB2B4bp35lKnSfJt2V+zzlyi1JkiSp8x0FfBBYCLwNrI2NU58yFKOJwN+S7sotCs4iSZIkqbvNAS4BRgFPAntj4wyu0wvdeaQnWP4VMDY2iiRJkqQeMRa4FJgJvAq8EhtnYJ1c6L5IKnMfD84hSZIkqTctzuYdYE1wlpo6sdBNAP6OVObmxUaRJEmS1ONOIn0F81hgNfBubJxDdVqhW0R68MlfA6ODs0iSJEkSpG7yEWAq6SmYW2PjVHRSobuSdFfu08E5JEmSJKmWZaRvEW4HNgRnATqn0H2VVOY+EJxDkiRJkgYzh/Qy8neBFcFZwgvdccDfk75mOTM4iyRJkiTV43jgYuAY4DHgQFSQyEI3k3RX7u9J73iQJEmSpLIYRXq1wXjSEzD7I0JEFbolpDL31aDrS5IkSVIznAdMB54DtrT74hGF7mJSmbsu4NqSJEmS1GyLgJOBzcCmdl643YXuKlKZu7TN15UkSZKkVpoHzCfdpWvbEzDbWeiuJ5W5c9t4TUmSJElql9nAmaTXGjzTjgu2q9B9mfQkyzPbdD1JkiRJijCd9MyQXcCTrb5YOwrdX5LuzM1tw7UkSZIkKdoUYDmp1K1q5YVaXejyF4af3OLrSJIkSVInmUgqdbtp4QvIW1nobiSVuVktvIYkSZIkdaoJVO7UrWzFBVpV6L5CKnOzW3R+SZIkSSqD8cBSYCewutknb0Wh+yypzM1pwbklSZIkqWwmkt5VtwV4upknbnah+wSpzC1s8nklSZIkqcwmAwuAV4B1zTppMwvdJcDXgbObeE5JkiRJ6hbTgFOBjcCmZpywWYVuCenO3IebdD5JkiRJ6kYzSe+qe4r0FcxhaUahO5FU5q5rwrkkSZIkqdvNBcYBD5NeazBkwy10R5HK3NeGeR5JkiRJ6iWLgT7gbuDgUE8y3EL3N8B/GeY5JEmSJKkXnU+6Q/fQUE8wnEJ3A+nu3LhhnEOSJEmSetlZwMsM8XUGQy1055CeaHnGED8vSZIkSUo3yGaSXjr+aqMfHkqhmwj8A3D1ED4rSZIkSTrULGAU8HtgbyMfHEqh++tsJEmSJEnNsYT0e7oHGvlQo4Xuk6S7c+Mb/JwkSZIkaXALgOeAdfV+oJFCN5P0EJSzG8skSZIkSarDeGACcD/QX88HGil0fwt8dQihJEmSJEn1mQe8Ddxbzx/XW+iuJD3VcuwQQ0mSJEmS6rMAWAtsONIf9tVxsvHAjcD0YYaSJEmSJB3ZdFIHm3CkP6znDt3XgL8ZbiJJkiRJUt3OIL2X7tHB/uhId+gWAl9uViJJkiRJUt2+TOpkAzpSofsCcG7T4kiSJEmS6nUuqZMNaLBCdx7w+abGkSRJkiQ14vOkblbTYIXuBuC0pseRJEmSJNXrNFI3q2mgQvdB4PqWxJEkSZIkNeJ6Ukc7zECF7lPArJbFkSRJkiTVaxapox2mVqE7A7i2pXEkSZIkSY24ltTVDlGr0F0NzG95HEmSJElSveaTutohqgvdOOCqtsSRJEmSJDXiKlJne191ofsocHHb4kiSJEmS6nUxqbO9r1ahkyRJkiR1pgEL3Wzg8vZmkSRJkiQ14HJSdwMOLXQfBua0O40kSZIkqW5zSN0NOLTQ+ds5SZIkSep873e3vNBNAi6IySJJkiRJasAFpA73fqE7B1gYFkeSJEmSVK+FpA53SKGTJEmSJJXDIYVueWAQSZIkSVJjlkMqdCOBRbFZJEmSJEkNWASMHJEdPBkcRpIkSZLUmMV9wPzoFJIkSZKkhs3vw5eJS5IkSVIZzekDZkenkCRJkiQ1bHYfMDM6hSRJkiSpYTP7gGnRKSRJkiRJDZvWB0yNTiFJkiRJatjUPmB8dApJkiRJUsPGjwDeAUZFJ5EkSZIkNWTvCOAAcFR0EkmSJElSQ97ri04gSZIkSRqaPmB/dAhJkiRJUsP29wG7o1NIkiRJkhq2uw/oj04hSZIkSWpYfx+wNTqFJEmSJKlhW/uALdEpJEmSJEkN29IHvBydQpIkSZLUsJf7gJeiU0iSJEmSGvZSH/B8dApJkiRJUsOe7wPWR6eQJEmSJDVsfR+wLhtJkiRJUjmsA9b1AfuANcFhJEmSJEn1WwPs68v+w4rIJJIkSZKkhqwAyAvd44FBJEmSJEmNeRwOLXRr47JIkiRJkuq0lqpCtxN4KCyOJEmSJKleD5E63PuFDuD+mCySJEmSpAa8392Khe73+JJxSZIkSepkz5O6G3BooXsJuLvdaSRJkiRJdbub1N2AQwsdwG/bm0WSJEmS1IBDOlutQudv6SRJkiSp89zPEQrdbuCOtsWRJEmSJNXrDlJne191oQO4HVjfljiSJEmSpHqsJ3W1Q9QqdM8At7U8jiRJkiSpXreRutohahU6gJ8Dm1saR5IkSZJUj82kjnaYgQrdw8DNLYsjSZIkSarXzaSOdpiBCh3AT4HnWhJHkiRJklSP50jdrKbBCt0jwI+aHkeSJEmSVK8fkbpZTYMVOoCbgMeaGkeSJEmSVI/HSJ1sQEcqdGuB7zctjiRJkiSpXt8ndbIBHVXHSdYB84AzmpFIkiRJknREPwO+Abw72B8d6Q4dwC7g28DrTQglSZIkSRrc66QO1n+kP6znDh3ABmACcMkwQkmSJEmSjuyfgW/W84f1FjpIpe500tcvJUmSJEnN9yvg69Rxdw4aK3T9wFvARcD4xnNJkiRJkgbxMul3c3W/aaCRQgfpASnHAZc1+DlJkiRJ0uD+Cfi3Rj7QaKEDWAOcCCwZwmclSZIkSYf7HvBfgb2NfGgohW4v6VbgImDWED4vSZIkSar4I+l3c883+sGhFDqAV4HdwIeAcUM8hyRJkiT1uldJZe6uoXx4qIUO4GnSe+w+OoxzSJIkSVIv+wbwr0P98HAKHcAjpDt05w/zPJIkSZLUa/6ZVOgODvUEwy10B0kPSZkOLB7muSRJkiSpV/yQBt43N5DhFjpIv6V7DjgFmNuE80mSJElSN/s16c7cxuGeqBmFDmAL6cmXpwMzm3ROSZIkSeo2DwP/SPr52rA1q9ABbAK2AmcB05p4XkmSJEnqBmtIX7P8bbNO2MxCB7Ae2AEsAyY3+dySJEmSVFYbSWXu1maetNmFDtLrDHaRSt3EFpxfkiRJkspkE+k3cz9s9olbUegAVpOe1nI2ML5F15AkSZKkTvcy6c7cd1px8lYVOoCVpCdgLgMmtPA6kiRJktSJNpPuzH2rVRdoZaEDWAG8CSzFr19KkiRJ6h0vku7MfbuVF2l1oQNYBWwHzgSmtOF6kiRJkhRpPanMfbfVF2pHoQN4kvSuuvnA9DZdU5IkSZLabTWpzP2oHRdrV6EDeIb0HdKTgdltvK4kSZIktcMfSGXutnZdsJ2FDmAD6f0L04F5bb62JEmSJLXKnaQyd3c7L9ruQgfpHQxPkV5nsCjg+pIkSZLUTDeRnmb5aLsvHFHoIP2e7lHgGOC8oAySJEmSNFz/i3RnbkPExaMKHaQXj/8e2AssB0YFZpEkSZKkRrwJ/DfSnbkdUSEiCx3AAeB+0msN5gPHx8aRJEmSpCN6lnRX7n+SOk2Y6EKXWwG8AEwD5gRnkSRJkqSB3E0qcz+JDgKdU+ggfed0FXAssCw4iyRJkiRV+zapzP0hOkiukwodwFbgPmAPsBgYHRtHkiRJktgO/A/S7+VeCs5yiE4rdADvkn5X9wowEzgpNo4kSZKkHvYo6a7c/yZ1lY7SiYUutyabUaS7dZIkSZLUTj8glbk7o4MMpJMLHaS7dPcCbwNnAmNj40iSJEnqAVuAfyKVueeCswyq0wsdpPfU3U96CuYUfAqmJEmSpNb5HanI/Qupi3S0MhS63FrgEeA94GzKlV2SJElSZ9tP+p3c14EHgrPUrWylaDvwa9JXMWfgA1MkSZIkDV/+4JP/TuocpVG2QpdbSXoZ+QjS3TpJkiRJGopvksrcr6KDDEVZCx3Aa8AdwKuku3UnxsaRJEmSVCKPk4rcN0jdopTKXOhyT5D+x/gTsJTu+DdJkiRJao39VO7K3RGcZdhGRAdosq8ANwIXRweRJEmS1HHuB74FfC86SLN0292s1cAfgD3AAmBMbBxJkiRJHWAblSdY3hucpam6rdAB7ADuJr3mYBSwMDaOJEmSpEC3korc/yF1ha7SbV+5rDYB+ItsloYmkSRJktROq4DvZLMrNEkLdeMduqJ3SS8jfwR4h/Q1zONCE0mSJElqpR3A/yU9vfIXpE7Qtbr9Dl21q0kPTvlMdBBJkiRJTXcL8F3g9ugg7dJrhQ5gNPAl4MvAhcFZJEmSJA3fA8APstkTnKWterHQ5U4hFbsvkb6KKUmSJKlc1lEpci/GRonRy4Uudw7wReALwNTgLJIkSZKObCtwE/BD4PHgLKEsdBWXUyl2I4OzSJIkSTrcPlKJu4n0qrKeZ6E73HXA54Dro4NIkiRJet/NwI9J75VTxkJX29GkUvc54KrgLJIkSVIvu4NU5H4MHAjO0nEsdIMbB9wAfBa4IjiLJEmS1EvuAn4C/BTYHZylY1no6jOJVOxuAC4NziJJkiR1s3tIJe6nwM7gLB3PQteY40kvJb8ei50kSZLUTPeQfid3C/BGcJbSsNANzWRSsfsMfhVTkiRJGo67SCXuFmBHcJbSsdANzwTSUzE/jQ9PkSRJkhpxB/Az0lMrdwVnKS0LXXMcSyp112Xjf6+SJEnS4Q6SClxe5N6NjVN+Fo/muwb4FHAt6Q6eJEmS1Ot2AbcBPwd+EZylq1joWudSUqm7FpgVnEWSJEmKsJlU5G4jPfRETWaha73lpLt21wBLgrNIkiRJ7bCadCfuF8CK4CxdzULXPieTSt0ngcuCs0iSJEmt8Dvg30lFblNwlp5goWu/McAnsrkaGB8bR5IkSRqWfuB24JfZvB0bp7dY6GJdQip1nwAWBGeRJEmSGrGOVOBuB+4LztKzLHSdYR7pPXZX4ovKJUmS1NnuAn5Feo/chuAsPc9C11lGUil2VwEzYuNIkiRJALxGKnB5kdsXG0c5C13nWgZ8PJsLg7NIkiSpNz0I3JnNyuAsqsFC1/nGkUrdn2V7emwcSZIkdbnXSQXu19neHRtHg7HQlctS4GPZfCQ4iyRJkrrLvcBvslkVnEV1stCV00gqxe5jwNzYOJIkSSqpjVRK3G/wt3GlY6ErvznAR0lPx7yC9BVNSZIkaSC7SU+qvAv4LfB8bBwNh4Wuu5xPKnWXAxcFZ5EkSVJneQC4m1Tk/hicRU1ioetOo0il7nLgMuCs2DiSJEkK8hTwO1KRuxvYGxtHzWah637TSaUun9mxcSRJktRiL5FKXD6vx8ZRK1noess84FLSEzIvBU6IjSNJkqQm2QbcQ3pS5T3Ahtg4ahcLXe9aRCp2ebkbHxtHkiRJDeqnUuLuBdbExlEEC50AlgMfLoxPypQkSepMu4HfF2ZFYBZ1AAudqp0NXEIqdpfgnTtJkqRo/cB9pAJ3H/BEaBp1FAudBrMMuLgwx8fGkSRJ6hlvAPcXZmVsHHUqC53qdQaVYncRMDM2jiRJUtd5mfSuuLzEPRMbR2VgodNQnEoqdRdmszA2jiRJUmmtBR7M5gHghdg4KhsLnYZrCpVidyHwwdg4kiRJHe9hKiXuQWB7bByVmYVOzXQ0cAHwoWwuACaFJpIkSYq3E3gI+EM2DwEHQhOpa1jo1EoLSaUun9Nj40iSJLXNs6Tils/a2DjqVhY6tctk4HzSVzLPz2Z0aCJJkqTm2QP8MZuHs70jNJF6goVOURaTyl0+PlhFkiSVzVpSecvnydg46kUWOnWCCcB5hfkAcEJoIkmSpMNtAx4FHinMrtBE6nkWOnWiOVSKXT5HhyaSJEm96ACpwOUl7lHg+dBEUhULncpgGXBuYZbExpEkSV1sNfBYYVbGxpEGZ6FT2YwklbpzsjkXWBCaSJIkldk6UnF7PJvHgH2hiaQGWOhUduOAs6tmfmgiSZLUydYDT1TN7tBE0jBY6NRt8oK3vLB9/50kSb3rWWAFqbjl2wKnrmGhU7cbTfoN3vJsLwOWhiaSJEmttIr0u7eVpAK3kvSOOKkrWejUa0ZQKXX5XgqMjQwlSZKG5C1SgctLXL4PRoaS2slCJ8Fc0pMzl2Z7CTA7NJEkSarlJdJTKFeTyttqYGNoIimYhU463CRgMZVytzibkZGhJEnqMfuAJ0mlrbh3RoaSOo2FTqrP6cCiwiwmvQBdkiQ1x3PAmqp5NjSRVAIWOmloRlMpd2cV9tTIUJIklcRWUmF7Kpu8wPnwEqlBFjqpeaYCZ9aYyZGhJEkKtgN4umqeArZFhpK6hYVOaq0ZwBmkYndGYaZEhpIkqUW2A88U5ulsvxYZSupmFjqp/aYBC0nFbiHp93kLgZMiQ0mS1KBXgLU1ZktkKKnXWOikzjCeSrE7vWokSYr2bNWszXZ/ZChJFjqp0y0ozPzCsQ9fkSS1whZgPbCusPOR1IEsdFL5TCSVu+qZB4wNzCVJKo+3gA2k0lY9bwbmktQgC53UPWaQSt08YG5hzwXGBOaSJMV5G9hIKm8bC8cb8EElUlew0Endbwap1J1WY08KzCVJap6dpBdzb6yxLW5SF7PQSb1rMjBngDk1MJckaWAvAM8PMDsCc0kKYqGTVG0EqdANNNPioklST9hCKm4DzcG4aJI6jYVOUiOOA07J5uTCzufEoFySVDavApsK82Jhvwi8E5RLUslY6CQ1yzFUit3sbIrHs4BRYekkqb32ApuBl7LZVHW8Cdgflk5S17DQSWqXqaRSNwuYWWPPJJVCSSqD/cDL2WyusTcDW8PSSeoZFjpJnWIalWJ30gAzPiydpF7TD7xSY14u7C1h6SQpY6GTVBbjSL/RO5H0Kobqnc+4qICSSmM36VH++bxa2MXj3VEBJaleFjpJ3WQsMJ1U7KbXmGmFfXRQRkmtcwB4nXTnbEt2XD2vZfutoIyS1FQWOkm9aArpN33Tsl09JxS2L1+X4u0EtpF+k5bv6tmS7e1BGSUphIVOkgZ2NKnUnQAcX9jVMyWb44HRIUmlctkDvEEqX9uz4+rZVtjbSHffJElVLHSS1DzHAZNJ5W5y1UyqsSdm27uAKrOdhXkT2JEdF3dxtmfb96xJUhNY6CQp3sQaM6Gw8xlfY4/Dp39qePpJD//oB3bV2Pm8WdjVI0kKYqGTpPLLi10+Ywu7esYU9hjSV0SLx8VR59lTNW9nUzx+q7CrZ3dh59Pf1n+BJKmpLHSSpFqOI5W64wozqmofmx2PKhwfC4zMdn5cPcdkM5L0O8VjqnY+RxV2Pn2Fnc+Iwi5OLQer5k+Fnc97hf0e6bdbxeN89lftfdnx/uy4et7NJj/eW9j58TvZcXHngcDJ6AAAAA5JREFUswe/pihJqvL/AawpymYju7lBAAAAAElFTkSuQmCC";
      const option = {
        series: [
          {
            type: "wordCloud",
            //用来调整词之间的距离
            gridSize: 30,
            //用来调整字的大小范围
            // Text size range which the value in data will be mapped to.
            // Default to have minimum 12px and maximum 60px size.
            sizeRange: [12, 55],
            rotationRange: [0, 0],
            // rotationRange: [-45, 0, 45, 90],
            // shape: "circular",
            // Text rotation range and step in degree. Text will be rotated randomly in range [-90,                                                                             90] by rotationStep 45
            //用来调整词的旋转方向，，[0,0]--代表着没有角度，也就是词为水平方向，需要设置角度参考注释内容
            // rotationRange: [-45, 0, 45, 90],
            // rotationRange: [0, 0],
            // drawOutOfBound: true,
            //随机生成字体颜色
            maskImage: maskImage,
            textStyle: {
              // fontWeight: "bold",
              color: function () {
                let num = Math.floor(Math.random() * 3);
                return that.color2[num];
                // return ("rgb(" +[Math.round(Math.random() * 160),Math.round(Math.random() * 160),Math.round(Math.random() * 160),].join(",") +")");
              },
            },
            //位置相关设置
            // Folllowing left/top/width/height/right/bottom are used for positioning the word cloud
            // Default to be put in the center and has 75% x 80% size.
            //数据
            left: 0,
            top: 0,
            width: "100%",
            height: "100%",
            right: 0,
            bottom: 0,
            data: this.worldValue,
          },
        ],
      };
      this.chart.setOption(option);
    },
    initChart() {
      let that = this;
      this.chart = echarts.init(document.getElementById("ciyun"));

      let maskImage = new Image();
      maskImage.src =
          "data:image/png;base64,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";
      const option = {
        series: [
          {
            type: "wordCloud",
            //用来调整词之间的距离
            gridSize: 9,
            //用来调整字的大小范围
            // Text size range which the value in data will be mapped to.
            // Default to have minimum 12px and maximum 60px size.
            sizeRange: [12, 55],
            rotationRange: [0, 0],
            // rotationRange: [-45, 0, 45, 90],
            // shape: "circular",
            // Text rotation range and step in degree. Text will be rotated randomly in range [-90,                                                                             90] by rotationStep 45
            //用来调整词的旋转方向，，[0,0]--代表着没有角度，也就是词为水平方向，需要设置角度参考注释内容
            // rotationRange: [-45, 0, 45, 90],
            // rotationRange: [0, 0],
            drawOutOfBound: true,
            //随机生成字体颜色
            maskImage: maskImage,
            textStyle: {
              // fontWeight: "bold",
              color: function () {
                let num = Math.floor(Math.random() * 3);
                return that.color2[num];
                // return ("rgb(" +[Math.round(Math.random() * 160),Math.round(Math.random() * 160),Math.round(Math.random() * 160),].join(",") +")");
              },
            },
            //位置相关设置
            // Folllowing left/top/width/height/right/bottom are used for positioning the word cloud
            // Default to be put in the center and has 75% x 80% size.
            //数据
            left: 0,
            top: 0,
            width: "100%",
            height: "100%",
            right: 0,
            bottom: 0,
            data: this.value.splice(0, 50),
          },
        ],
      };
      this.chart.setOption(option);
    },
    line() {
      let mycharts = echarts.init(document.getElementById("line"));
      const x = [...new Set(this.trendData.map(i => i.hour))].sort((a, b) => a - b);
      const x1 = x.map(o => o <= 12 ? o + "am" : o + "pm");
      let option = {
        tooltip: {
          trigger: "axis",
        },
        grid: {
          top: "20%",
          left: "2%",
          right: "2%",
          bottom: "10%",
          containLabel: true,
        },
        color: this.color,
        legend: {
          position: 'center',
          top: "10px",
          textStyle: {
            color: '#E6F7FF',
            fontSize: 8,
          },
        },
        xAxis: {
          type: "category",
          data: x1,
          interval: 0,
          axisTick: {
            show: false,
          },
          axisLine: {
            lineStyle: {
              color: "#0f1d91",
            },
          },
          axisLabel: {
            color: '#afb3b6'
          },
        },
        yAxis: {
          type: "value",
          splitLine: {
            show: true,
            lineStyle: {
              color: "#0f1d91",
              width: 1,
            },
          },
          axisLine: {
            show: true,
            lineStyle: {
              color: "#0f1d91",
            },
          },
          axisLabel: {
            color: "#afb3b6",
          },
        },
        series: [
          {
            name: "蒙牛",
            type: "line",
            symbolSize: 8,
            symbol: "circle",
            color: '#1794FF',
            smooth: true,
            data: this.trendData.filter(i => i.brandName === "蒙牛").sort((s1, s2) => s1.hour - s2.hour).map(i => i.buzz),
          },
          {
            name: "伊利",
            type: "line",
            symbolSize: 8,
            symbol: "circle",
            color: '#1EE7E7',
            smooth: true,
            data: this.trendData.filter(i => i.brandName === "伊利").sort((s1, s2) => s1.hour - s2.hour).map(i => i.buzz),
          },
          {
            name: "可口可乐",
            type: "line",
            symbolSize: 8,
            symbol: "circle",
            color: '#E3595F',
            smooth: true,
            data: this.trendData.filter(i => i.brandName === "可口可乐").sort((s1, s2) => s1.hour - s2.hour).map(i => i.buzz),
          },
          {
            name: "VIVO",
            type: "line",
            symbolSize: 8,
            symbol: "circle",
            color: '#762BF2',
            smooth: true,
            data: this.trendData.filter(i => i.brandName === "VIVO").sort((s1, s2) => s1.hour - s2.hour).map(i => i.buzz),
          },
          {
            name: "阿迪达斯",
            type: "line",
            symbolSize: 8,
            symbol: "circle",
            color: '#144AF4',
            smooth: true,
            data: this.trendData.filter(i => i.brandName === "阿迪达斯").sort((s1, s2) => s1.hour - s2.hour).map(i => i.buzz),
          },
        ],
      };
      mycharts.setOption(option);
    },
    pie() {
      let mycharts = echarts.init(document.getElementById("pie"));
      let option = {
        tooltip: {
          trigger: "item",
        },
        grid: {
          top: "20%",
          left: "2%",
          right: "2%",
          bottom: "20%",
          containLabel: true,
        },
        legend: {
          orient: "vertical",
          top: 50,
          right: 20,
          textStyle: {
            color: "#fff",
            fontSize: 14,
          },
        },
        color: this.color1,
        series: [
          {
            type: "pie",
            radius: ['40%', '70%'],
            itemStyle: {
              borderRadius: 10,
              borderColor: '#fff',
              borderWidth: 0.4
            },
            data: this.sentimentList,
            label: {
              show: true,
              fontSize: "14",
              color: "#fff",
              formatter: function (param) {
                let p = param.value == 0 ? "" : param.percent + "%";
                return param.name + p;
              },
            },
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: "rgba(0, 0, 0, 0.5)",
              },
            },
          },
        ],
      };
      mycharts.setOption(option);
    },
    bar() {
      let mycharts = echarts.init(document.getElementById("bar"));
      let option = {
        tooltip: {
          trigger: "axis",
        },
        color: ["#1794FF", "#1EE7E7", "#E3595F", "#7725FD", "#FF8F1F", "#EB2F96", "#FFC300", "#144AF4"],
        legend: {
          data: ["新闻", "微信", "微博", "问答", "抖音", "快手", "虎扑", "B站"],
          position: 'center',
          top: "10px",
          width: '250px',
          textStyle: {
            color: '#E6F7FF',
            fontSize: 8,
          },
        },
        grid: {
          top: "28%",
          left: "2%",
          right: "8%",
          bottom: "10%",
          containLabel: true,
        },
        yAxis: [
          {
            type: "category",
            data: [...new Set(this.distributionData.map(i => i.brandName))],
            axisLabel: {
              color: "#afb3b6",
              interval: 0,
            },
            inverse: true,
            axisTick: {
              show: false,
            },
            axisLine: {
              show: true,
              lineStyle: {
                color: "#0f1d91",
              },
            },
          },
        ],
        xAxis: [
          {
            type: "value",
            axisLine: {
              show: true,
              lineStyle: {
                color: "#0f1d91",
              },
            },
            splitLine: {
              show: true,
              lineStyle: {
                color: "#0f1d91",
                width: 1,
              },
            },
            axisLabel: {
              color: "#afb3b6",
            },
          },
        ],
        series: [
          {
            name: '新闻',
            type: 'bar',
            stack: 'total',
            emphasis: {
              focus: 'series'
            },
            data: this.distributionData.filter(i => i.platform === "新闻").map(i => i.buzz)
          },
          {
            name: '微信',
            type: 'bar',
            stack: 'total',
            emphasis: {
              focus: 'series'
            },
            data: this.distributionData.filter(i => i.platform === "微信").map(i => i.buzz)
          },
          {
            name: '微博',
            type: 'bar',
            stack: 'total',
            emphasis: {
              focus: 'series'
            },
            data: this.distributionData.filter(i => i.platform === "微博").map(i => i.buzz)
          },
          {
            name: '问答',
            type: 'bar',
            stack: 'total',
            emphasis: {
              focus: 'series'
            },
            data: this.distributionData.filter(i => i.platform === "问答").map(i => i.buzz)
          },
          {
            name: '抖音',
            type: 'bar',
            stack: 'total',
            emphasis: {
              focus: 'series'
            },
            data: this.distributionData.filter(i => i.platform === "抖音").map(i => i.buzz)
          },
          {
            name: '快手',
            type: 'bar',
            stack: 'total',
            emphasis: {
              focus: 'series'
            },
            data: this.distributionData.filter(i => i.platform === "快手").map(i => i.buzz)
          },
          {
            name: '虎扑',
            type: 'bar',
            stack: 'total',
            emphasis: {
              focus: 'series'
            },
            data: this.distributionData.filter(i => i.platform === "虎扑").map(i => i.buzz)
          },
          {
            name: 'B站',
            type: 'bar',
            stack: 'total',
            emphasis: {
              focus: 'series'
            },
            data: this.distributionData.filter(i => i.platform === "B站").map(i => i.buzz)
          },
        ],
      };
      mycharts.setOption(option);
    },
    // 获取当前时间
    currentTime() {
      setInterval(this.getDate, 1000);
    },
    getDate() {
      const hh =
          new Date().getHours() < 10
              ? "0" + new Date().getHours()
              : new Date().getHours();
      const mm =
          new Date().getMinutes() < 10
              ? "0" + new Date().getMinutes()
              : new Date().getMinutes();
      const ss =
          new Date().getSeconds() < 10
              ? "0" + new Date().getSeconds()
              : new Date().getSeconds();
      this.nowTime = hh + ":" + mm + ":" + ss;
    },
  },
};
</script>
<style>
::-webkit-scrollbar {
  display: none;
  /* Chrome Safari */
}

.home {
  width: 100%;
  height: 1080px;
  background: url(../assets/img/bg.png);
  background-size: 100% 100%;
}

.time {
  text-align: right;
  font-size: 18px;
  color: #fff;
  padding-right: 85px;
}

.header {
  width: 100%;
  height: 97px;
  background: url(../assets/img/header.png);
  background-size: cover;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.header-logo {
  width: 131px;
  height: 44px;
  padding-left: 660px;
  padding-top: 15px;
}

.contant {
  display: flex;
  padding: 0 16px;
  box-sizing: border-box;
}

.con_left {
  width: 500px;
}

.l_title {
  width: 330px;
  height: 52.5px;
  background: url(../assets/img/title.png);
  background-size: cover;
  color: #fff;
  text-align: left;
  font-size: 20px;
  line-height: 20px;
  letter-spacing: 2px;
}

.l_title span {
  display: block;
  padding-top: 13px;
  margin-left: 45px;
}

.line {
  width: 460px;
  height: 279px;
  background: url(../assets/img/border.png);
  background-size: 100% 100%;
  margin-top: -5px;
  margin-left: 3px;
}

.pie {
  width: 460px;
  height: 279px;
  background: url(../assets/img/border.png);
  background-size: 100% 100%;
  margin-top: -5px;
  margin-left: 3px;
}

.bar {
  width: 460px;
  height: 279px;
  background: url(../assets/img/border.png);
  background-size: 100% 100%;
  margin-top: -5px;
  margin-left: 3px;
}

.left_center {
  margin-top: 10px;
}

.con_center {
  flex: 1;
  padding: 0 10px;
}

.con_right {
  width: 500px;
}

.scroll {
  height: 280px;
  margin-top: 20px;
  overflow: hidden;
  position: relative;
}

.scroll_weibo {
  height: 280px;
  margin-top: 20px;
  overflow: hidden;
  position: relative;
}

.scroll_header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 458px;
  height: 36px;
  line-height: 36px;
  background: #0c2d5c;
  position: absolute;
  top: 0px;
  z-index: 1;
  padding: 0 12px;
  box-sizing: border-box;
}

.scroll_header_item {
  font-size: 14px;
  width: calc(458px / 4);
  text-align: center;
}

.scroll_main {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.scroll_main_item {
  width: calc(458px / 4);
  text-align: center;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: 14px;
  margin-bottom: 29px;
}

ul {
  list-style-type: none;
}

.scroll1 {
  height: 200px;
}

.scroll ul li {
  width: 436px;
  height: 74px;
  background: url(../assets/img/kuang.png);
  background-size: cover;
  margin: 0 auto 10px auto;
  font-size: 18px;
  color: #559eff;
  padding: 0 12px;
  box-sizing: border-box;
  /* display: flex; */
}

.li_title {
  padding: 10px 0px 2px 10px;
  border-bottom: 1px solid rgba(52, 135, 246, 0.5);
  line-height: 20px;
}

.t_left {
  color: rgba(255, 255, 255, 0.5);
  font-size: 12px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.t_left > img {
  width: 14px;
  height: 11px;
  margin-right: 8px;
}

.t_left1 {
  padding-bottom: 5px;
}

.t_left1 .img {
  width: 14px;
  height: 14px;
  margin-right: 7px;
  vertical-align: sub;
}

.t_time {
  font-size: 12px;
  margin-left: 5px;
  color: rgba(255, 255, 255, 0.5);
}

.li_text {
  font-size: 12px;
  line-height: 16px;
  padding-top: 5px;
  text-align: justify;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  color: #FFFFFF;
  overflow: hidden;
}

.li_text span {
  font-size: 18px;
}

.li_text1 {
  font-size: 12px;
  line-height: 16px;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
}

/*.zhezhao {*/
/*  width: 376px;*/
/*  height: 55px;*/
/*  background-color: rgba(0, 0, 0, 0.2);*/
/*  position: absolute;*/
/*  left: 63px;*/
/*  bottom: 0;*/
/*}*/

/*.zhezhao1 {*/
/*  height: 80px;*/
/*}*/

.ciyun {
  border-top: 0.1px solid transparent;
  width: 346px;
  height: 200px;
  margin: 0 auto;
}

.ciyun_word {
  height: 250px;
  margin-top: calc((279px - 250px) / 2);
}

.ciyun1 {
  width: 100%;
  height: 350px;
  margin: 38px auto 0 auto;
}

.scroll2 {
  width: 881px;
  height: 166px;
  overflow: hidden;
  position: relative;
  margin-left: 10px;
  letter-spacing: 1px;
}

.scroll2 .center_text {
  width: 416px;
  font-size: 14px;
  color: rgba(255, 255, 255, 0.7);
  padding: 20px 22px 0 22px;
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
}

.ciyun_center {
  width: 884px;
  height: 563px;
  border-radius: 50%;
  margin: 56px auto 23px auto;
}

.ciyun_center_top {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.card {
  text-align: center;
  width: 400px;
  height: 122px;
  background: #f00;
  background: url("../assets/img/card-bg.png");
  background-size: 100% 100%;
}

.card_title,
.card_day {
  font-size: 24px;
  color: #FFFFFF;
}

.card_day {
  font-size: 14px;
}

.card_list {
  margin-top: 6px;
  display: flex;
  justify-content: space-around;
  align-items: center;
  padding: 0 24px 7px 24px;
}

.card_list_item_title,
.card_list_item_num {
  font-size: 16px;
}

.green {
  color: #1EE7E7;
}

.blue {
  color: #1794FF;
}

.card_list_item_num {
  font-size: 20px;
  font-weight: bold;
}

.center_bottom {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.left_l {
  height: 316px;
  overflow: hidden;
}

.border {
  width: 460px;
  height: 279px;
  background: url(../assets/img/border.png);
  background-size: 100% 100%;
  margin-top: -5px;
  margin-left: 3px;
}

.center_title {
  padding: 12px 22px 0 22px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.topic {
  font-size: 14px;
  font-weight: 400;
  color: #FFFFFF;
}

.tip {
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  flex-wrap: wrap;
  color: #fff;
  font-size: 14px;
  margin: 15px auto 0 auto;
  width: 442px;
  height: 53px;
  background: linear-gradient(90deg, rgba(28, 59, 104, 0.00) 0%, #1C3B68 49%, rgba(28, 59, 104, 0.00) 100%);
}

.tip > div {
  width: calc(442px / 3.5);
  text-align: left;
}

.tip span {
  font-family: "SourceHanSansCN-Regular";
  color: #fff;
}
</style>
